import {OnlyTextHeaderArg} from "@psdk/frame-father";
import {CMode} from "../types";

export class CPrint extends OnlyTextHeaderArg<CPrint> {
  private readonly mode: CMode;

  constructor(options?: {
    mode?: CMode
  }) {
    super();
    this.mode = options?.mode ?? CMode.NORMAL;
  }

  header(): string {
    return this.mode == CMode.HORIZONTAL ? "POPRINT" : "PRINT";
  }
}



